import { clampToPlate } from "./uploadedConversationsVisualizerParticles"

export type PlatePoint = ReturnType<typeof clampToPlate>

export function insetOverlayAnchor(anchor: PlatePoint, insetScale: number) {
  return clampToPlate(
    0.5 + (anchor.u - 0.5) * insetScale,
    0.5 + (anchor.v - 0.5) * insetScale,
  )
}

export function clampPointToRadius(
  point: PlatePoint,
  radiusLimit: number,
  center: PlatePoint = { u: 0.5, v: 0.5 },
) {
  const deltaU = point.u - center.u
  const deltaV = point.v - center.v
  const radius = Math.hypot(deltaU, deltaV)
  if (radius <= radiusLimit) {
    return point
  }
  const scale = radiusLimit / Math.max(radius, 1e-6)
  return clampToPlate(center.u + deltaU * scale, center.v + deltaV * scale)
}

export function resolveChaosAnchor(
  anchorU: number,
  anchorV: number,
  amp: number,
  seedHash: number,
) {
  const angle = ((seedHash >>> 5) % 6280) / 1000
  const radius = 0.0045 + amp * 0.0036
  return clampToPlate(
    anchorU + Math.cos(angle) * radius,
    anchorV + Math.sin(angle) * radius,
  )
}
